import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router-dom';

const HomeStores = (props) => {

    let Store = props.stores.map((post, i)=>{
        return (
            <div className="col-6" key={post.ID}>
                <Link to={`/vendor/${post.ID}`}>
                    <div className="card mb-2">
                        <div className="storeHeight">
                            <img src={post.IMAGE} className="card-img-top" alt={post.NAME} />
                        </div>
                        <div className="card-body pt-07 pb-07 pr-06 pl-06 storeTextHeight">
                            <p className="card-text text-dgrey font-size-12 font-weg-500 mb-0">{post.NAME}</p>
                            {post.ITEMS!='' && <p className="mb-0 text-slgrey"><small>{post.ITEMS} items</small></p>}
                        </div>
                    </div>
                </Link>
            </div>
        );
    });

    return (
        <div className="section pt-0 pb-2">
            <div className="section-title font-size-17 mb-05 text-sdgrey">Store in Store</div>
            <div className="row">
                {Store}
            </div>
        </div>
    );
}
  
export default HomeStores;


// WEBPACK FOOTER //
// ./src/components/HomeStores.js